import styled from 'styled-components';
import { useState, useEffect } from 'react';
import ImagePlaceholder from '~/assets/svgs/camera.svg';

const UploadPhoto = ({ image, onImageChange }) => {
  const [selectedImage, setSelectedImage] = useState(image);

  useEffect(() => {
    onImageChange?.(selectedImage);
  }, [selectedImage]);

  useEffect(() => {
    if (selectedImage !== image) {
      setSelectedImage(image);
    }
  }, [image]);

  return (
    <S.Container>
      <S.UploadButton>
        {selectedImage ? (
          <S.Preview src={URL.createObjectURL(selectedImage)}></S.Preview>
        ) : (
          <ImagePlaceholder width="80px" height="80px" viewBox="0 0 100 100" />
        )}
        <S.UploadButtonText>
          {selectedImage ? 'Edit Photo' : 'Upload Photo'}
        </S.UploadButtonText>
        <S.FileInput
          type="file"
          accept=".png, .jpg, .jpeg"
          hidden
          onChange={(e) => {
            setSelectedImage(e.target.files[0] || null);
          }}
        />
      </S.UploadButton>
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    display: flex;
    justify-content: center;
  `,
  Preview: styled.img`
    width: 80px;
    height: 80px;
    background: #ececee;
    border-radius: 50%;
    border: none;
    object-fit: cover;
  `,
  FileInput: styled.input``,
  UploadButton: styled.label`
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    padding: 1rem 0;
    display: inline-block;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
      text-decoration: underline;
    }
  `,
  UploadButtonText: styled.span`
    margin-top: 0.75rem;
  `,
};

export default UploadPhoto;
